"use client";

import Logo from "@/app/(components)/generics/Logo/Logo";
import PulseCircle from "@/app/(components)/generics/PulseCircle/PulseCircle";
import { ModalStore } from "@/app/stores/ModalStore";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { DefaultProps } from "@/app/types/common/DefaultProps";
import { FLOW_INPUTS, FLOW_OUTPUTS } from "./ConceptFlow.logic";
import styles from "./ConceptFlow.module.css";

type Props = DefaultProps & {};

export default function ConceptFlow(props: Props) {
  const T = useT();

  const openSignUp = () => ModalStore.getState().openSignUp(props.params);

  return (
    <div className={styles.container}>
      <div className={styles.flow}>
        <div className={`${styles.side} ${styles.inputs}`}>
          <div className={styles.nodes}>
            {FLOW_INPUTS.map((key) => (
              <div className={styles.node} key={key}>
                <span className={styles.chip}>{T(key)}</span>
                <span className={styles.wire} />
              </div>
            ))}
          </div>
        </div>

        <PulseCircle className={styles.hub} onClick={openSignUp}>
          <Logo min light ignoreBrand nonInteractive className={styles.hubLogo} />
        </PulseCircle>

        <div className={`${styles.side} ${styles.outputs}`}>
          <div className={styles.nodes}>
            {FLOW_OUTPUTS.map((key) => (
              <div className={styles.node} key={key}>
                <span className={styles.wire} />
                <button
                  type="button"
                  className={`${styles.chip} ${styles.chipClickable}`}
                  onClick={openSignUp}
                >
                  {T(key)}
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className={styles.goal}>
        <span className={styles.downWire} />
        <button
          type="button"
          className={`${styles.goalBadge} ${styles.goalClickable}`}
          onClick={openSignUp}
        >
          {T(TKey.HOME_MEIDLY_FLOW_GOAL)}
        </button>
      </div>

      <span className={styles.titleWire} aria-hidden="true" />

      <h2 className={styles.title}>
        {T(TKey.HOME_MEIDLY_FLOW_TITLE_1)}{" "}
        <span className={styles.titleEcho}>{T(TKey.HOME_MEIDLY_FLOW_TITLE_2)}</span>
      </h2>
    </div>
  );
}
